import { useEffect, useState } from "react";
import CustomStore from "devextreme/data/custom_store";
import { Result } from "antd";
import Loader from "Common/Loader";
import DataGrid, { Paging, Pager, SearchPanel, Summary, TotalItem, Column, } from "devextreme-react/cjs/data-grid";
import { Card } from "react-bootstrap";
import UserMasterActionButtonsModal from "./UserMasterActionButtonsModal";
import AddSalesPerson from "modules/store/SalePerson/components/AddSalePerson";
import { getAllUsers } from "../services";

const UserMasterDataList = () => {
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [permissionDetails, setPermissionDetails] = useState<string[]>([]);

  useEffect(() => {
    const authUserString = localStorage.getItem("authPOSUser");
    if (authUserString) {
      const authUser = JSON.parse(authUserString);
      const permissionData = authUser?.permissions || [];
      setPermissionDetails(permissionData);
    }
  }, []);

  const HasPermission = (permission: string): boolean => {
    return permissionDetails.includes(permission);
  };

  const dataSource = (): any | undefined => {
    return new CustomStore({
      key: "id",
      load: async (loadOptions) => {
        try {
          const search = JSON.parse(JSON.stringify(loadOptions));
          let parameterList = new URLSearchParams();
          for (const [key, value] of Object.entries(search)) {
            parameterList.append(key, JSON.stringify(value));
          }
          const response = await getAllUsers(parameterList);
          // return {
          //   data: response?.data || [],
          //   totalCount: response?.data.length || 0,
          // };
          return response
        } catch (error) {
          console.error("Data loading error:", error);
          return { data: [], totalCount: 0 };
        }
      },
    });
  };

  const reloadDataSource = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <>
      {loading && <Loader />}
      <div className="page-content">
        <div className="container-fluid">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="m-0">User Master</h5>
              {/* {HasPermission("SalesPerson.Write") && (
                <AddSalesPerson reloadDataSource={reloadDataSource} />
              )} */}
            </Card.Header>
            <Card.Body>
              {HasPermission("User.Read") ? (
                <DataGrid
                  dataSource={dataSource()}
                  remoteOperations={{ groupPaging: true }}
                  showRowLines={true}
                  keyExpr="id"
                  key={refreshKey}
                  showBorders={true}
                  onContentReady={(e) => {
                    const hasData = e.component.totalCount() > 0;
                    e.component.option("pager.visible", hasData);
                    e.component.option("paging.visible", hasData);
                  }}
                >
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 25, 50, 100]}
                    showNavigationButtons={true}
                    displayMode="full"
                    showInfo={true}
                  />
                  <Summary>
                    <TotalItem
                    // column="userName"
                    // summaryType="count"
                    // displayFormat="Total Users: {0}"
                    />
                  </Summary>
                  <Paging defaultPageSize={10} />
                  <SearchPanel visible width={240} placeholder="Search..." />


 {(HasPermission("User.Write") || HasPermission("User.Delete")) && <Column
                    caption="Action"
                    width="15%"
                    cssClass="text-center"
                    cellRender={({ data }) => (
                      <div className="d-flex justify-content-center align-items-center gap-2">
                        <UserMasterActionButtonsModal
                          userSelectedId={data.id as number}
                          onDeleteSuccess={reloadDataSource}
                          onUpdateSuccess={reloadDataSource}
                          reloadDataSource={reloadDataSource}
                          permissionData={data}
                        />
                      </div>
                    )}
                  />}
                  <Column dataField="userName" caption="Username" dataType="string" width="15%" />
                  <Column dataField="name" caption="Name" dataType="string" width="20%" />
                  <Column dataField="emailAddress" caption="Email" dataType="string" width="20%" />
                  <Column dataField="mobileNumber" caption="Mobile Number" dataType="string" width="15%" />
                  <Column dataField="roleName" caption="Role" dataType="string" width="15%" />
                 
                </DataGrid>
              ) : (
                null
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default UserMasterDataList;
